// Auto Appy character library, copied from auto-appy src/features/Workspace/characters.js.
// A character is only a look: it never changes what a bot can do or access.
import appy from './assets/characters/appy.webp';
import tara from './assets/characters/tara.webp';
import nila from './assets/characters/nila.webp';
import remy from './assets/characters/remy.webp';
import kiran from './assets/characters/kiran.webp';
import atlas from './assets/characters/atlas.webp';
import echo from './assets/characters/echo.webp';
import maya from './assets/characters/maya.webp';
import sia from './assets/characters/sia.webp';
import hari from './assets/characters/hari.webp';
import asha from './assets/characters/asha.webp';
import dev from './assets/characters/dev.webp';
import roshni from './assets/characters/roshni.webp';
import veer from './assets/characters/veer.webp';
import om from './assets/characters/om.webp';
import diya from './assets/characters/diya.webp';
import neel from './assets/characters/neel.webp';
import kabir from './assets/characters/kabir.webp';
import meera from './assets/characters/meera.webp';
import appyFull from './assets/characters/appy-full.webp';
import taraFull from './assets/characters/tara-full.webp';
import remyFull from './assets/characters/remy-full.webp';
import atlasFull from './assets/characters/atlas-full.webp';
import echoFull from './assets/characters/echo-full.webp';
import mayaFull from './assets/characters/maya-full.webp';
import kiranFull from './assets/characters/kiran-full.webp';
import nilaFull from './assets/characters/nila-full.webp';
import hariFull from './assets/characters/hari-full.webp';
import siaFull from './assets/characters/sia-full.webp';

export const CHARACTERS = [
  { key: 'appy', label: 'Appy · classic white', tint: '#E3EFF7', image: appy, full: appyFull },
  { key: 'tara', label: 'Teal, headset', tint: '#DBF0EB', image: tara, full: taraFull },
  { key: 'remy', label: 'Amber, cap', tint: '#F7EAD1', image: remy, full: remyFull },
  { key: 'atlas', label: 'Cobalt, tool belt', tint: '#DDE6F6', image: atlas, full: atlasFull },
  { key: 'echo', label: 'Graphite, headphones', tint: '#DCEEEF', image: echo, full: echoFull },
  { key: 'maya', label: 'Sage, glasses', tint: '#E7EDDF', image: maya, full: mayaFull },
  { key: 'kiran', label: 'Olive, cap', tint: '#EAE8D6', image: kiran, full: kiranFull },
  { key: 'nila', label: 'Sky blue', tint: '#E1EBF8', image: nila, full: nilaFull },
  { key: 'hari', label: 'Mustard, cap', tint: '#F6E9C9', image: hari, full: hariFull },
  { key: 'sia', label: 'Lilac, glasses', tint: '#EDE6F5', image: sia, full: siaFull },
  { key: 'asha', label: 'Coral, cap', tint: '#F6E3DB', image: asha },
  { key: 'dev', label: 'Navy and silver', tint: '#E1E7F1', image: dev },
  { key: 'roshni', label: 'Coral and white', tint: '#F8E2DD', image: roshni },
  { key: 'veer', label: 'Copper, apron', tint: '#F5E0D1', image: veer },
  { key: 'om', label: 'Charcoal, tool belt', tint: '#E4E5E8', image: om },
  { key: 'diya', label: 'Rose gold', tint: '#F6E1E1', image: diya },
  { key: 'neel', label: 'Steel blue', tint: '#E2E8EF', image: neel },
  { key: 'kabir', label: 'Forest green, satchel', tint: '#E0EAE1', image: kabir },
  { key: 'meera', label: 'Human look · Meera', tint: '#ECEDEA', image: meera, human: true },
];

const byKey = Object.fromEntries(CHARACTERS.map((character) => [character.key, character]));

export const characterFor = (key) => (key && byKey[key]) || null;
